import { colors } from '@mui/material';
import { colors as customColors } from 'utils/colorsSteps';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: customColors.navBar,
    light: customColors.navBar,
    main: customColors.navBar,
    //main: colors.blue['A400'],
  },
  secondary: {
    contrastText: white,
    dark: customColors.greenLight,
    light: customColors.greenLight,
    main: customColors.greenLight,
    //main: colors.blue['A400'],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
    menu: '#c1c6c9',
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: colors.grey[200],
  yellow: '#f4c363',
  green: '#5fba68',
};
